import React, { useEffect, useState } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
} from '@material-ui/core';

import Abertura from './Abertura';

import { instanceAxios } from 'src/InstanceAxios';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
    margin: '0 auto',
    textAlign: 'center',
  },
});

const columns = [
  { id: 'etapa', label: 'Etapa' },
  { id: 'status', label: 'Status' },
  { id: 'encerramento', label: 'Encerramento' },
  { id: 'observacao', label: 'Observação para o Cliente' },
];

export const Etapas = ({ serviceId }) => {
  const [abertura, setAbertura] = useState({});

  const classes = useStyles();

  useEffect(() => {
    const token = localStorage.getItem('toobiauth');

    const fetchEtapas = async () => {
      await instanceAxios(token)
        .get(`/statusEtapasServicos/${serviceId}`)
        .then((res) => {
          if (res.data.etapasAbetura) {
            setAbertura(res.data.etapasAbetura);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchEtapas();
  }, [serviceId]);

  return (
    <Table className={classes.container} component={Paper}>
      <TableHead>
        <TableRow>
          {columns.map((column) => (
            <TableCell
              key={column.id}
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              {column.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <Abertura abertura={abertura} />
      </TableBody>
    </Table>
  );
};
